import { render, staticRenderFns } from "./FiveStarRatingUpdate.vue?vue&type=template&id=aa6b79a4&"
import script from "./FiveStarRatingUpdate.vue?vue&type=script&lang=js&"
export * from "./FiveStarRatingUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports